import Enlang from './entries/en-US';
import Eslang from './entries/es_ES';
import Ptlang from './entries/pt_PT';
import BrLang from './entries/pt_BR';
import { addLocaleData } from 'react-intl';

const AppLocale = {
  US: Enlang,
  ES: Eslang,
  PT: Ptlang,
  BR: BrLang
};

addLocaleData(AppLocale.US.data);
addLocaleData(AppLocale.ES.data);
addLocaleData(AppLocale.PT.data);
addLocaleData(AppLocale.BR.data);

export default AppLocale;
